import React from 'react';
import SubLayout from '../../components/layouts/SubLayout';

export default function Ingredients() {
  return (
    <>
      <SubLayout title="Ingredients" />
    </>
  );
};